<template>
  <div
    class="cemsPreAlarmDialog absolute_center"
    :class="{
      _boxBg_dark_secondLevel: styleType == 'typeDark',
      _boxBg_green_secondLevel: styleType == 'typeGreen',
      _boxBg_blue_secondLevel: styleType == 'typeBlue',
    }"
  >
    <div
      :class="!inDetailPage ? 'selfClose_btn' : 'selfReturn_btn'"
      @click="close()"
    ></div>
    <div class="_boxTitle">{{ titleName }}</div>
    <div class="_yellowLine"></div>
    <div class="_innerBox">
      <div class="mem_main_box" v-show="!inDetailPage">
        <div class="public-form">
          <div class="public-form-left">
            <el-form :inline="true" class="secondLevel-form-inline">
              <el-form-item class="secondLevel-label" label="分厂/所属区域：">
                <el-select
                  class="secondLevel-select"
                  v-model="params.branchFactoryId"
                  placeholder="全部"
                >
                  <el-option label="全部" value=""></el-option>
                  <el-option
                    v-for="(item, i) in nameIdData"
                    :key="i"
                    :label="item.name"
                    :value="item.nameId"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="secondLevel-label" label="设备名称：">
                <el-input
                  class="secondLevel-input"
                  v-model="params.deviceName"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
              <el-form-item class="secondLevel-label" label="监测指标：">
                <el-select
                  class="secondLevel-select"
                  v-model="params.categoryId"
                  placeholder="全部"
                >
                  <el-option label="全部" value=""></el-option>
                  <el-option label="SO2" value="17"></el-option>
                  <el-option label="SO2折算" value="117"></el-option>
                  <el-option label="NOX" value="18"></el-option>
                  <el-option label="NOX折算" value="118"></el-option>
                  <el-option label="颗粒物" value="19"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="secondLevel-label" label="超标预测：">
                <el-select
                  class="secondLevel-select"
                  v-model="params.warning"
                  placeholder="全部"
                >
                  <el-option label="全部" value=""></el-option>
                  <el-option label="正常" value="0"></el-option>
                  <el-option label="预警" value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item style="margin-left: 10px" class="secondLevel-label">
                <a class="self_btn" @click="check_click">查询</a>
                <a class="self_btn" @click="reset_click">重置</a>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="table_box" style="height: 580px !important">
          <el-table
            :header-cell-class-name="getHeaderCellClass"
            :header-row-class-name="getHeadRowClass"
            :cell-class-name="getCellClass"
            :row-class-name="getRowClass"
            class="secondLevel_table"
            :data="tableData"
            @row-click="rowClick"
            id="secondLevel_table"
            style="width: 100%"
          >
            <el-table-column
              align="center"
              type="index"
              width="100px"
              label="序号"
              prop=""
            >
              <template #default="scope">
                {{
                  scope.$index +
                  1 +
                  (Number(pageNo) - 1) * Number(pageSize ? pageSize : 50)
                }}
              </template>
            </el-table-column>
            <el-table-column align="center" label="分厂/所属区域" prop="branchFactory">
              <template #default="scope">
                <span>{{
                  scope.row.branchFactory ? scope.row.branchFactory : "--"
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="生产工艺线"
              prop="productionLine"
              width="300px"
            >
              <template #default="scope">
                <span
                  :title="scope.row.productionLine ? scope.row.productionLine : '--'"
                  >{{ scope.row.productionLine ? scope.row.productionLine : "--" }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="设备名称"
              prop="deviceName"
              width="300px"
            >
              <template #default="scope">
                <span :title="scope.row.deviceName ? scope.row.deviceName : '--'">{{
                  scope.row.deviceName ? scope.row.deviceName : "--"
                }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="监测指标" prop="signalName">
              <template #default="scope">
                <!--span>{{getcategoryName(scope.row.categoryId)}}</span-->
                <span>{{ scope.row.signalName }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="超标预测" prop="warning">
              <template #default="scope">
                <span>{{ scope.row.warning ? scope.row.warning : "--" }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="预测时段" prop="time">
              <template #default="scope">
                <span>{{ scope.row.rangStartTime + "--" + scope.row.rangEndTime }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div
          class="secondLevel-pagination_box pagination"
          v-if="!pagination && tableData.length"
        >
          <el-pagination
            :page-size="50"
            layout="total,prev, pager, next,jumper"
            :total="total"
            @current-change="handleCurrentChange"
            :current-page="pageNo"
          />
          <p>跳转</p>
        </div>
      </div>
      <div class="detailPage" v-show="inDetailPage">
        <div class="deviceMsg">
          <div class="icon_title"><img src="./img/potBg.png" /><span>设备信息</span></div>
          <el-row style="margin-bottom: 30px">
            <el-col :span="8">
              <div class="msg">
                <p>分厂/所属区域:</p>
                <span>{{ detailData.branchFactory }}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="msg">
                <p>生产工艺线:</p>
                <span>{{ detailData.productionLine }}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="msg">
                <p>设备名称:</p>
                <span>{{ detailData.deviceName }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <div class="msg">
                <p>监测指标:</p>
                <span>{{ detailData.signalName }}</span>
              </div>
            </el-col>
          </el-row>
          <div class="timePicker">
            <el-form :inline="true" class="demo-form-inline">
              <el-form-item label="起止时间：" prop="timeArr">
<!--                <el-date-picker
                  v-model="timeArr"
                  :disabledDate="pickerOptions"
                  type="datetimerange"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="dateChange"
                >
                </el-date-picker>-->
                <DatePicker
                  init-width="420px"
                  :start-time-str="timeArr[0]"
                  :end-time-str="timeArr[1]"
                  @dateChange="dateChange"
                  topPx="50px"
                  :current-date-list="timeArr"
                  dateType="timerange"
                >
                </DatePicker>
              </el-form-item>
              <el-form-item>
                <a class="self_btn" @click="checkFun">查询</a>
                <a class="self_btn" @click="resetFun">重置</a>
              </el-form-item>
            </el-form>
            <div class="tipsBox">
              预警准确率：<span>{{ accuracy }}</span
              >%
            </div>
          </div>
          <div class="icon_title">
            <img src="./img/potBg.png" /><span>超标预警趋势图</span>
          </div>
          <div v-show="!nodata" class="chart" ref="chart"></div>
          <div v-show="nodata" class="chart nodata">此时间段内暂无数据</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import getOpt from "./chartOpt.js";
import { unwarp, dateFormat } from "@/utils/tools.js";
import { ElMessage } from "element-plus";
import { DatePicker } from "@/modules/commonDatePicker";
export default {
  props: ["globalInstance", "preType"],
  setup(props) {
    const preType = props.preType;
    const globalInstance = props.globalInstance;
    return { globalInstance, preType };
  },
  components:{
    DatePicker
  },
  data() {
    return {
      nodata: false,
      customerId: this.$store.state.customerId,
      params: {
        branchFactoryId: "",
        deviceName: "",
        categoryId: "",
        warning: "",
      },
      pageNo: 1,
      pageSize: 50,
      tableData: [],
      nameIdData: [],
      total: 0,
      styleType: "",
      inDetailPage: false,
      timeArr: [
        dateFormat("YYYY-mm-dd HH:MM:SS", new Date().getTime() - 60 * 60 * 1000),
        dateFormat("YYYY-mm-dd HH:MM:SS", new Date()),
      ],
      chart: null,
      detailData: {},
      accuracy: 0,
    };
  },
  created() {
    this.styleType = this.$store.state.styleType;
  },
  mounted() {
    if (this.preType === "ALL") {
      this.params.categoryId = "";
      this.params.warning = "1";
    } else if (this.preType === "SO2") {
      this.params.categoryId = "17";
      this.params.warning = "1";
    } else if (this.preType === "NOX") {
      this.params.categoryId = "18";
      this.params.warning = "1";
    } else if (this.preType === "KLW") {
      this.params.categoryId = "19";
      this.params.warning = "1";
    }
    this.getareaList();
    this.check_click();
  },
  computed: {
    curStyleTypeVal() {
      return this.$store.state.styleType;
    },
    titleName() {
      return this.inDetailPage ? "CEMS设备超标预测详情" : "CEMS设备超标预测";
    },
    getcategoryName() {
      return (id) => {
        let categoryName = "--";
        if (id == 17) {
          categoryName = "SO2";
        } else if (id == 18) {
          categoryName = "NOX";
        } else if (id == 19) {
          categoryName = "颗粒物";
        }
        return categoryName;
      };
    },
    getHeaderCellClass() {
      return (obj) => {
        if (this.styleType == "typeDark") {
          return "thClass";
        } else if (this.styleType == "typeGreen") {
          return "thClass_green";
        }
      };
    },
    getHeadRowClass() {
      return (obj) => {
        if (this.styleType == "typeDark") {
          return "headTrClass";
        } else if (this.styleType == "typeGreen") {
          return "headTrClass_green";
        }
      };
    },
    getCellClass() {
      return (obj) => {
        if (this.styleType == "typeDark") {
          return "tdClass";
        } else if (this.styleType == "typeGreen") {
          return "tdClass_green";
        }
      };
    },
    getRowClass() {
      return (obj) => {
        if (this.styleType == "typeDark") {
          return "trClass";
        } else if (this.styleType == "typeGreen") {
          return "trClass_green";
        }
      };
    },
  },
  watch: {
    curStyleTypeVal: {
      handler(newVal, oldVal) {
        this.styleType = newVal;
      },
      deep: true,
    },
  },
  unmounted() {
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  },
  methods: {
    pickerOptions(time) {
      return (
        time.getTime() > new Date().getTime() ||
        time.getTime() < new Date().getTime() - 2 * 60 * 60 * 1000
      );
    },
    dateChange(e) {
      // console.log("e", e);
      /*if (new Date(e[1]).getTime() - new Date(e[0]).getTime() > 2 * 60 * 60 * 1000) {
        ElMessage({
          message: "最长时间维度可选择两小时",
          type: "warning",
        });
        e[1] = new Date(e[0]).getTime() + 60 * 60 * 1000;
      }
      this.timeArr = e.map((i) =>
        dateFormat("YYYY-mm-dd HH:MM:SS", new Date(i).getTime())
      );*/
      if (this.compareTime(e)) {
        ElMessage({
          message: "最长时间维度可选择两小时",
          type: "warning",
        });
      }
      this.timeArr = e;
      // console.log("timeArr", this.timeArr);
    },
    compareTime(time) {
      let beginTimes = time[0].substring(0, 10).split('-');
      let endTimes = time[1].substring(0, 10).split('-');

      let beginTime = beginTimes[1] + '-' + beginTimes[2] + '-' + beginTimes[0] + ' ' + time[0].substring(10, 19);
      let endTime = endTimes[1] + '-' + endTimes[2] + '-' + endTimes[0] + ' ' + time[1].substring(10, 19);
      let flag = (Date.parse(endTime) - Date.parse(beginTime)) / 3600 / 1000;
      return flag > 2;
    },
    check_click() {
      this.pageNo = 1;
      this.getData();
    },
    async getData() {
      let paramsList = {
        customerId: this.customerId,
        branchFactoryId: this.params.branchFactoryId,
        deviceName: this.params.deviceName,
        categoryId: this.params.categoryId,
        warning: this.params.warning,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      };
      let findcemsPredictionList =
        CONFIG.requestName + this.$apiOpt.findcemsPredictionList;
      let data = await this.$apiUtils.get(findcemsPredictionList, paramsList);
      this.tableData = data.records;
      this.total = data.total;
    },
    reset_click() {
      this.params = {
        branchFactoryId: "",
        deviceName: "",
        categoryId: "",
        warning: "",
      };
      this.pageNo = 1;
      this.getData();
    },
    rowClick(e) {
      // console.log("eeeeeeeeeee", e);
      this.inDetailPage = true;
      this.detailData = e;
      this.getDetailData(this.detailData);
    },
    async getDetailData(data) {
      //调接口获取基本信息
      const chartData = await this.getDetailChartData(data);
      this.$nextTick(() => {
        if (!this.chart) {
          this.chart = echarts.init(this.$refs.chart);
        }
        let optionStr = getOpt(chartData);
        unwarp(this.chart).setOption(optionStr);
      });
    },
    async getDetailChartData(e) {
      let cemsPredictionDetail = CONFIG.requestName + this.$apiOpt.cemsPredictionDetail;
      let data = await this.$apiUtils.get(cemsPredictionDetail, {
        customerId: this.customerId,
        deviceNo: e.deviceNo,
        categoryId: e.categoryId,
        signalNo: e.signalNo,
        startTime: this.timeArr[0],
        endTime: this.timeArr[1],
      });
      this.accuracy = data.accuracy;
      let obj = {
        xData: [],
        yData: [],
        alarmData: [],
        basisData: {
          type: e.signalName,
          unit: data.unit,
          basisValue: data.threshold,
        },
      };
      if (!data.cemsPredictionTrendList) {
        this.nodata = true;
      } else {
        this.nodata = false;
      }
      data.cemsPredictionTrendList &&
        data.cemsPredictionTrendList.forEach((i) => {
          obj.xData.push(i.time);
          obj.yData.push(i.value);
          obj.alarmData.push(i.times);
        });
      return obj;
    },
    async getareaList() {
      let getNameId = CONFIG.requestName + this.$apiOpt.getNameId;
      let data = await this.$apiUtils.get(getNameId, {
        customerId: this.customerId,
      });
      if (data) this.nameIdData = data || [];
    },
    handleCurrentChange(val) {
      this.tableData = [];
      this.pageNo = val;
      this.getData();
    },
    close() {
      if (!this.inDetailPage) {
        let that = this._.appContext.app;
        this.$popup.close(that);
      } else {
        this.inDetailPage = false;
        this.timeArr = [
          dateFormat("YYYY-mm-dd HH:MM:SS", new Date().getTime() - 60 * 60 * 1000),
          dateFormat("YYYY-mm-dd HH:MM:SS", new Date()),
        ];
        this.detailData = {};
        if (this.chart) {
          this.chart.dispose();
          this.chart = null;
        }
      }
    },
    checkFun() {
      this.getDetailData(this.detailData);
    },
    resetFun() {
      this.timeArr = [
        dateFormat("YYYY-mm-dd HH:MM:SS", new Date().getTime() - 60 * 60 * 1000),
        dateFormat("YYYY-mm-dd HH:MM:SS", new Date()),
      ];
      this.getDetailData(this.detailData);
    },
  },
};
</script>

<style lang="scss" scoped>
// 针对卫星版（例：浙江万泰大屏62）弹窗高度大于二级菜单调整
._boxBg_blue_secondLevel {
  height: 920px;
  ._boxTitle {
    margin-bottom: 20px;
  }
}
.absolute_center {
  top: 49%;
}
.cemsPreAlarmDialog .secondLevel-pagination_box {
  margin: 0;
}
.cemsPreAlarmDialog .selfReturn_btn {
  right: 40px;
}

.mem_main_box {
  height: 100%;
  position: relative;
  .top_msg_box {
    height: 144px;
    position: relative;
    .important_follow_box {
      width: 100%;
      height: 144px;
      background: linear-gradient(
        180deg,
        rgba(108, 115, 255, 0.34) 0%,
        rgba(107, 151, 255, 0.2) 48%,
        rgba(58, 116, 255, 0.1) 100%,
        #0049fa 100%,
        #0049fa 100%
      );
      border: 1px solid #8badff;
      position: relative;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .important_inner {
        height: 100%;
        display: flex;
        justify-content: space-around;
        align-items: center;
        // padding: 18px 10px 0 125px;
        position: relative;
        &::after {
          content: "";
          width: 2px;
          height: 88px;
          position: absolute;
          top: 50%;
          margin-top: -44px;
          right: -137px;
          background: rgb(9, 7, 32);
        }
        .important_inner_name {
          align-items: center;
          .num {
            font-size: 60px;
            font-weight: 400;
            font-style: italic;
            color: rgba(255, 255, 255, 1);
            line-height: 60px;
            text-shadow: #00ffaa 0px 0px 10px;
            text-align: center;
          }
          .blueFont {
            font-size: 20px;
            line-height: 33px;
            color: #5bb4ff;
          }
        }
      }
    }
  }
  .public-form {
    .public-form-left {
      .secondLevel-form-inline {
        .secondLevel-label {
          .el-form-item__label {
            // color: #99f5ff !important;
            // font-size: 20px;
            // padding: 0 8px 0 0;
          }
        }
        .secondLevel-select {
          width: 218px;
          height: 40px;
          border: 1px solid #99f5ff;
          color: #99f5ff;
          background: #071127;
          font-size: 16px;
        }
      }
    }
  }
  .secondLevel-pagination {
    display: flex;
    // align-items: center;
    justify-content: flex-end;
  }
}
.detailPage {
  .deviceMsg {
    .icon_title {
      display: flex;
      margin-bottom: 30px;
      span {
        margin-left: 7px;
        font-size: 20px;
        font-weight: 500;
      }
    }
    .msg {
      font-size: 16px;
      line-height: 16px;
      display: flex;
      p {
        display: inline-block;
        width: 110px;
        text-align: end;
        flex-shrink: 0;
      }
      span {
        color: #f4c48f;
        width: 100%;
        margin-left: 20px;
        margin-right: 40px;
        border-bottom: 1px dashed #f4c48f;
        padding-left: 5px;
      }
    }
  }
  .timePicker {
    display: flex;
    align-items: center;
    & > div {
      font-size: 22px;
      margin-left: 220px;
      width: 300px;
      height: 60px;
      background: #000000;
      border-radius: 2px;
      border: 1px solid #8ec2ff;
      font-size: 21px;
      color: #f5a623;
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        font-size: 30px;
        font-weight: bold;
        color: #4be0ff;
        margin: 0 10px;
      }
    }
  }
  .chartsTitle {
    color: orange;
    font-size: 26px;
    font-weight: 600;
  }
  .chart {
    width: 100%;
    height: 520px;
    margin-top: 20px;
    &.nodata {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 25px;
    }
  }
}
</style>
<style lang="scss" scoped>
._boxBg_green_secondLevel {
  .mem_main_box {
    .top_msg_box {
      .important_follow_box {
        background: rgba(6, 56, 53, 0.7);
        border: 1px solid #05fffa;
        box-shadow: 6px 5px 14px 2px #05fbf6;
        border-radius: 15px;
        .important_inner {
          &::after {
            background: rgb(33, 177, 187);
          }
          .important_inner_name {
            .num {
            }
            .blueFont {
              color: #c8dde1;
            }
          }
        }
      }
    }
    .public-form {
      margin-top: 10px;
      .public-form-left {
        .secondLevel-form-inline {
          .secondLevel-label {
            .el-form-item__label {
            }
          }
          .secondLevel-select {
            width: 218px;
            height: 40px;
            border: 1px solid #99f5ff;
            color: #99f5ff;
            background: #071127;
            font-size: 16px;
          }
        }
      }
    }
    .secondLevel-pagination {
      display: flex;
      // align-items: center;
      justify-content: flex-end;
    }
  }
}
</style>
<style lang="scss">
.cemsPreAlarmDialog {
  .secondLevel-label {
    .el-form-item__label {
      color: #99f5ff !important;
      font-size: 20px;
      padding: 0 8px 0 0;
    }
  }
  .table_box {
    height: 450px !important;
    // overflow: auto;
    .secondLevel_table {
      border: 1px solid #84aaff40 !important;
      background: #01132d40 !important;
      pointer-events: all;
      .el-table__body-wrapper {
        overflow-y: auto;
        height: 520px;
      }
    }
    .thClass {
      background: #01122ba6 !important;
      border-bottom: 1px solid #cccccc28 !important;
    }

    .thClass > .cell {
      font-size: 22px;
      color: rgba(200, 216, 255, 1);
      text-align: center !important;
    }

    .tdClass {
      border-right: 1px solid #84aaff40 !important;
      border-bottom: 1px solid #84aaff40 !important;
      background: #01122b66 !important;
    }
    .tdClass > .cell {
      font-size: 22px !important;
      color: #afafaf !important;
      font-family: "fontNormal" !important;
      text-align: center !important;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }

    .headTrClass {
      border: 1px solid rgba(132, 170, 255, 0.5) !important;
    }

    .thClass_green {
      background: rgba(0, 73, 76, 0.8) !important;
      border-bottom: 1px solid rgba(5, 255, 250, 0.2) !important;
    }

    .thClass_green > .cell {
      font-size: 22px;
      color: rgba(200, 216, 255, 1);
      text-align: center !important;
    }

    .tdClass_green {
      border-right: 1px solid rgba(5, 255, 250, 0.2) !important;
      border-bottom: 1px solid rgba(5, 255, 250, 0.2) !important;
      background: rgba(178, 254, 252, 0.2) !important;
    }
    .tdClass_green > .cell {
      font-size: 22px !important;
      color: #afafaf !important;
      font-family: "fontNormal" !important;
      text-align: center !important;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }

    .headTrClass_green {
      border: 1px solid rgba(5, 255, 250, 1) !important;
    }
  }
}
</style>
<style>
.cemsPreAlarmDialog .detailPage .el-form-item .el-form-item__label {
  color: #fff;
  font-size: 16px;
  margin-left: 40px;
}
.cemsPreAlarmDialog .el-date-editor {
  width: 490px !important;
}
/* 分页 */
.cemsPreAlarmDialog .secondLevel-pagination_box {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  /* margin: 30px 100px 0 0; */
  margin: 20px 0 0 0;
}
.cemsPreAlarmDialog .secondLevel-pagination_box p {
  font-size: 28px;
}
.cemsPreAlarmDialog .secondLevel-pagination_box .el-pagination .el-pagination__total {
  margin-right: 50px;
}
.cemsPreAlarmDialog .secondLevel-pagination_box .el-pagination {
  text-align: right;
  padding: 0 130px 0 0;
}
.cemsPreAlarmDialog .secondLevel-pagination_box .el-pagination button,
.cemsPreAlarmDialog .el-pagination span:not([class*="suffix"]) {
  font-size: 26px;
  width: 80px;
  height: 80px;
  line-height: 80px;
  color: #ffffff;
}
.cemsPreAlarmDialog .secondLevel-pagination_box .el-pager li,
.cemsPreAlarmDialog .secondLevel-pagination_box .el-pager li.btn-quicknext,
.cemsPreAlarmDialog .secondLevel-pagination_box .el-pager li.btn-quickprev {
  font-size: 26px;
  width: 80px;
  height: 80px;
  line-height: 80px;
  color: #ffffff;
  background: transparent;
}
.cemsPreAlarmDialog .secondLevel-pagination_box .el-pager li.active {
  color: #55abf9;
}
.cemsPreAlarmDialog .secondLevel-pagination_box .el-pagination .btn-next,
.cemsPreAlarmDialog .el-pagination .btn-prev,
.cemsPreAlarmDialog .el-pagination button:disabled {
  background: transparent;
  color: #ffffff;
}
.cemsPreAlarmDialog .secondLevel-pagination_box .el-pagination .btn-next .el-icon,
.cemsPreAlarmDialog .el-pagination .btn-prev .el-icon {
  font-size: 28px;
}
.cemsPreAlarmDialog .secondLevel-pagination_box .el-pagination__editor.el-input {
  width: 80px;
  height: 50px;
}
.cemsPreAlarmDialog
  .secondLevel-pagination_box
  .el-pagination__editor.el-input
  .el-input__inner {
  height: 36px;
  font-size: 22px;
  border: 1px solid #dcdfe6;
  background: transparent;
  color: #fff;
}
._boxBg_blue_secondLevel
  .el-select__popper
  .el-select-dropdown
  .el-scrollbar
  .el-select-dropdown__wrap
  .el-scrollbar__view
  .el-select-dropdown__item {
  color: #fff;
}
</style>
